import { normalizeProductCategory } from "@the-drop/customer-shared/normalize-product-category";
import { getCustomerApiBaseUrl } from "./api-base";

import flowerImg from "../assets/category-placeholders/flower.jpg";
import ediblesImg from "../assets/category-placeholders/edibles.jpg";
import vapesImg from "../assets/category-placeholders/vapes.jpg";
import concentratesImg from "../assets/category-placeholders/concentrates.jpg";
import accessoriesImg from "../assets/category-placeholders/accessories.jpg";

/**
 * Static category placeholders extracted from the customer redesign mockup
 * (`drop_website.html` p-order section). The API doesn't expose per-product
 * images yet, so the cascade in `resolveProductImageUrl` falls back to one
 * of these by category. Maps the 4 canonical categories from
 * `normalizeProductCategory` (locked 2026-05-06: customers only see
 * Concentrate / Flower / Vapes / Edibles, with cartridge products in
 * Vapes even though the API classifies them as Concentrate).
 */
type ItemShape = {
  productCategory: string;
  productName?: string;
  productImageUrl?: string | null;
};

export function categoryPlaceholderUrl(item: ItemShape): string {
  const cat = normalizeProductCategory(item.productCategory, item.productName);
  switch (cat) {
    case "Edibles":
      return ediblesImg;
    case "Vapes":
      return vapesImg;
    case "Concentrate":
      return concentratesImg;
    case "Accessories":
      return accessoriesImg;
    case "Flower":
      return flowerImg;
  }
}

/**
 * Cascade used by `ProductCard` and the cart line-item thumbnail:
 *   1. real `productImageUrl` if present (API will eventually populate)
 *   2. category-derived placeholder
 *
 * Always returns a usable URL — callers never need a sage-block fallback.
 */
export function resolveProductImageUrl(item: ItemShape): string {
  const raw = item.productImageUrl?.trim() ?? "";
  if (raw.length > 0) {
    // POS images we host ourselves are stored as API-relative paths
    // (`/api/v1/pos-product-images/...`); vendor CDNs are absolute.
    return raw.startsWith("/") ? `${getCustomerApiBaseUrl()}${raw}` : raw;
  }
  return categoryPlaceholderUrl(item);
}
